export const PREFIX = "shop-sections";
